<template>
  <table class="coupon-caption-table">
    <thead>
      <tr>
        <th>{{ $t('labWorkOrderTable.labels.corrosionLvl') }}</th>
        <th
          v-for="sample in samples"
          :key="sample.id"
        >
          <template v-if="sample.coupon">
            {{ sample.coupon.name }}
          </template>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(normField,index) in normFields"
        :key="normField"
      >
        <td
          class="first-cell"
          :class="normField"
        >
          {{ $t(`labWorkOrderTable.corrosionLvl.${normField}`) }}
        </td>
        <td
          v-for="sample in samples"
          :key="sample.id"
          class="center-column"
        >
          <template v-if="sample.coupon.norm">
            <span v-if="normFields[index + 1]">
              [ {{ sample.coupon.norm[normField] | fixed }} - {{ sample.coupon.norm[normFields[index+1]] | fixed }} [
            </span>
            <span v-else> {{ sample.coupon.norm[normField] | fixed }} + </span>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
    filters: {
        fixed(value) {
            if (!value) return '';
            return value.toFixed(2);
        },
    },
    props: {
        analysisRequests: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            normFields: [
                'excellent',
                'veryGood',
                'good',
                'fair',
                'poor',
                'severe',
            ],
            samples: [],
        };
    },
    watch: {
        analysisRequests: {
            handler() {
                this.samples = this.analysisRequests[0].samples || [];
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
  .coupon-caption-table {
    margin-top: 20px;
    thead {
      background-color: #26384B;
      color: #fff;
      th {
        padding: 10px;
        text-align: left;
        border: 1px solid transparent;
      }
    }

    td {
      padding: 10px;
      border-right: 1px solid #C4C4C4;
      border-bottom: 1px solid #C4C4C4;
      width: 225px;
    }

    .center-column{
        text-align: center;
        font-weight: bold;
    }

    .first-cell {
      width: 274px;
      color: #fff;
      &.excellent {
        background-color: #2A750F;
      }
      &.veryGood {
        background-color: #64A44D;
      }
      &.good {
        background-color: #B1C243;
      }
      &.fair {
        background-color: #D1A918;
      }
      &.poor {
        background-color: #EF4135;
      }
      &.severe {
        background-color: #AD1C3F;
      }
    }
  }
</style>
